import { render, staticRenderFns } from "./ExportSectionV2.vue?vue&type=template&id=5329413c&scoped=true"
import script from "./ExportSectionV2.vue?vue&type=script&lang=js"
export * from "./ExportSectionV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5329413c",
  null
  
)

export default component.exports